<template>
  <div class="row">
    <div class="col-12">
      <!--begin::Portlet-->
      <div class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__head">
          <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">
              Activity Log
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="row filter-types">
            <div class="col-12">
              <label>By Customer</label>
              <multiselect v-model="selected_customer" :options="customers"
                           track-by="uuid"
                           placeholder="Select a Customer" label="name" />
            </div>
            <div class="col-12">
              <label>By User</label>
              <multiselect v-model="selected_user" :options="filtered_users"
                           track-by="uuid"
                           placeholder="Select a User" label="name" />
            </div>
            <div class="col-12">
              <label>By Storage</label>
              <div class="input-group">
                <input v-model="storage_uuid" type="text"
                       class="form-control"
                       placeholder="Enter Uuid">
                <div class="input-group-append">
                  <button class="btn btn-ss-standout" type="button" @click="searchStorageUuid()">
                    Go!
                  </button>
                </div>
              </div>
            </div>
            <div class="col-12">
              <label>By Changes</label>
              <div class="input-group">
                <input v-model="changes" type="text"
                       class="form-control"
                       placeholder="Enter Uuid">
                <div class="input-group-append">
                  <button class="btn btn-ss-standout" type="button" @click="searchChanges()">
                    Go!
                  </button>
                </div>
              </div>
            </div>
            <div class="col-12">
              <label>By Item</label>
              <div class="input-group">
                <input v-model="item_uuid" type="text"
                       class="form-control"
                       placeholder="Enter Uuid">
                <div class="input-group-append">
                  <button class="btn btn-ss-standout" type="button" @click="searchItemUuid()">
                    Go!
                  </button>
                </div>
              </div>
            </div>
            <div class="col-12">
              <label>By Feed</label>
              <div class="input-group">
                <input v-model="feed_uuid" type="text"
                       class="form-control"
                       placeholder="Enter Uuid">
                <div class="input-group-append">
                  <button class="btn btn-ss-standout" type="button" @click="searchFeedUuid()">
                    Go!
                  </button>
                </div>
              </div>
            </div>
          </div>

          <data-table v-if="show_data_table" id="activity_log_table"
                      :columns="columns"
                      :server-side="true"
                      :pagination="{
                        enabled: true,
                        per_page: 15,
                      }"
                      :data-uri="data_uri" :static-params="static_params"
                      class="mt-4">
            <!-- Table Filters -->
            <template #_filters>
              <data-table-filters target="activity_log_table" :expanded="false"
                                  :form-columns="2"
                                  filter-layout="row" :filters="filters" />
            </template>

            <!-- Property Transformers -->
            <template #properties="props">
              <div v-if="props.row.description === 'items_updated'">
                <feed-items-update :row-properties="props.row.properties" />
              </div>

              <div v-else-if="props.row.description === 'created'">
                <role-creation v-if="props.row.subject_type === `App\\Models\\UserRole`" :row-properties="props.row.properties" />
                <standard-creation v-else :row-properties="props.row.properties" />
              </div>

              <div v-else-if="props.row.description === 'deleted'">
                <standard-delete :row-properties="props.row.properties" />
              </div>

              <div v-else-if="props.row.description === 'clip_converted'">
                <clip-converted :row-properties="props.row.properties" />
              </div>

              <div v-else-if="props.row.description === 'customer_retention_item'">
                <customer-retention retention-type="item" :row-properties="props.row.properties" />
              </div>

              <div v-else-if="props.row.description === 'customer_retention_storage'">
                <customer-retention retention-type="storage" :row-properties="props.row.properties" />
              </div>

              <div v-else-if="props.row.properties.attributes && props.row.properties.old">
                <standard-update :row-properties="props.row.properties" />
              </div>

              <div v-else>
                {{ props.row.properties }}
              </div>
            </template>
            <!-- End Property Transformers -->
            <template #causer="props">
              <a v-if="getCauserLink(props.row)" :href="getCauserLink(props.row)" _target="blank">{{ getCauserName(props.row) }}</a>
              <span v-else>{{ getCauserName(props.row) }}</span>
            </template>
            <template #subject_type="props">
              {{ props.row.subject_type | subject_type_filter }}
            </template>
            <template #subject="props">
              <div v-if="getSubjectLink(props.row) && props.row.event !== 'deleted'" style="word-break: break-word;">
                <a :href="getSubjectLink(props.row)" _target="blank">
                  {{ getSuitableName(props.row) }}
                </a>
              </div>
              <div v-else>
                <span>{{ getSuitableName(props.row) }}</span>
              </div>
            </template>
            <template #created_at="props">
              <span>{{ formatDateTime(props.value) }}</span>
            </template>
          </data-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import DataTable from "VuePartials/App/Storage/FDataTable/FDataTable.vue";
import DataTableFilters from "VuePartials/App/Storage/FDataTable/FDataTableFilters.vue";
import FeedItemsUpdate from "VuePartials/ActivityLog/FeedItemsUpdate";
import StandardUpdate from "VuePartials/ActivityLog/StandardUpdate";
import StandardCreation from "VuePartials/ActivityLog/StandardCreation";
import StandardDelete from "VuePartials/ActivityLog/StandardDelete";
import ClipConverted from "VuePartials/ActivityLog/ClipConverted";
import RoleCreation from "VuePartials/ActivityLog/RoleCreation";
import CustomerRetention from "VuePartials/ActivityLog/CustomerRetention";

export default {
  components: {
    CustomerRetention,
    RoleCreation,
    ClipConverted,
    DataTableFilters,
    StandardDelete,
    StandardCreation,
    StandardUpdate,
    DataTable,
    FeedItemsUpdate,
  },
  filters: {
    subject_type_filter(value) {
      if (!value) {
        return 'N/A';
      }
      return value.replace("App\\Models\\", "");
    },
  },
  data() {
    return {
      customers: window.customers,
      users: window.users,
      item_uuid: null,
      feed_uuid: null,
      changes: null,
      storage_uuid: null,
      selected_customer: null,
      selected_user: null,
      show_data_table: false,
      data_uri: `/api/v1/admin/activity-log`,
      columns: [
        {
          field: `subject_type`,
          display: `Subject`,
          sortable: true,
        },
        {
          field: `subject`,
          display: `Name`,
          sortable: false,
          min_width: 150,
        },
        {
          field: `description`,
          display: `Action`,
          sortable: true,
        },
        {
          field: `causer`,
          display: 'Causer',
          sortable: false,
        },
        {
          field: `properties`,
          display: `Changes`,
          sortable: false,
        },
        {
          field: `created_at`,
          display: `Created At`,
          sortable: true,
          active_sort: true,
          sort_dir: 'desc',
        },
      ],
      filters: [
        {
          name: `subject_type`,
          display: `Subject`,
          type: `text`,
        },
        {
          name: `description`,
          display: `Action`,
          type: `text`,
        },
      ],
    };
  },
  computed: {
    filtered_users() {
      if (this.selected_customer) {
        return this.selected_customer.users;
      } else {
        return window.users;
      }
    },
    static_params() {
      if (this.selected_user) {
        return [
          {
            field: 'user_uuid',
            value: this.selected_user.uuid,
          },
        ];
      } else if (this.selected_customer) {
        return [
          {
            field: 'customer_uuid',
            value: this.selected_customer.uuid,
          },
        ];
      } else if (this.item_uuid) {
        return [
          {
            field: 'item_uuid',
            value: this.item_uuid,
          },
        ];
      } else if (this.feed_uuid) {
        return [
          {
            field: 'feed_uuid',
            value: this.feed_uuid,
          },
        ];
      } else if (this.storage_uuid) {
        return [
          {
            field: 'storage_uuid',
            value: this.storage_uuid,
          },
        ];
      } else if (this.changes) {
        return [
          {
            field: 'changes',
            value: this.changes,
          },
        ];
      }

      return [];
    },
  },
  watch: {
    // whenever question changes, this function will run
    selected_customer: function (newValue) {
      if (newValue) {
        this.selected_user = null;
        this.item_uuid = null;
        this.feed_uuid = null;
        this.storage_uuid = null;
        this.changes = null;
        this.reInitDataTable();
      }
    },
    selected_user: function (newValue) {
      if (newValue) {
        this.selected_customer = null;
        this.item_uuid = null;
        this.feed_uuid = null;
        this.storage_uuid = null;
        this.changes = null;
        this.reInitDataTable();
      }
    },
  },
  methods: {
    searchItemUuid() {
      this.selected_customer = null;
      this.selected_user = null;
      this.feed_uuid = null;
      this.storage_uuid = null;
      this.changes = null;
      this.reInitDataTable();
    },
    searchFeedUuid() {
      this.selected_customer = null;
      this.selected_user = null;
      this.item_uuid = null;
      this.storage_uuid = null;
      this.changes = null;
      this.reInitDataTable();
    },
    searchStorageUuid() {
      this.selected_customer = null;
      this.selected_user = null;
      this.item_uuid = null;
      this.feed_uuid = null;
      this.changes = null;
      this.reInitDataTable();
    },
    searchChanges() {
      this.selected_customer = null;
      this.selected_user = null;
      this.item_uuid = null;
      this.feed_uuid = null;
      this.storage_uuid = null;
      this.reInitDataTable();
    },
    reInitDataTable() {
      const vm = this;
      // Force components to be re-mounted
      Vue.nextTick(() => {
        vm.show_data_table = false;
        Vue.nextTick(() => {
          vm.show_data_table = true;
        });
      });
    },
    getSuitableName(row) {
      // Usually in the case of deletion
      if (!row.subject && row.properties.attributes?.name) {
        return row.properties.attributes.name;
      }

      // If it's a deleted activity, try and get the name of thing thing it was attached to.
      if (!row.subject && row.description === 'deleted') {
        if (row.properties.attributes && row.properties.attributes.item) {
          return `Item : ${row.properties.attributes.item?.name ?? 'Unknown'}`;
        }

        if (row.properties.old) {
          const old_model = row.properties.old;
          return old_model.name ?? old_model.slug ?? old_model.uuid;
        }
      }

      if (!row.subject) {
        return "N/A (maybe deleted)";
      }

      if (row.subject.name) {
        return row.subject.name;
      }

      if (row.properties.attributes.item) {
        return `Item : ${row.properties.attributes.item?.name ?? 'Unknown'}`;
      }

      if (row.properties.attributes.storage) {
        return row.properties.attributes.storage?.name ?? 'Unknown';
      }

      if (row.properties.attributes.label) {
        return row.properties.attributes.label;
      }
    },
    getCauserName(row) {
      if (row.causer && row.causer.name) {
        return row.causer.name;
      } else {
        return 'System';
      }
    },
    getCauserLink(row) {
      if (row.causer && row.causer.uuid) {
        return `/users/${row.causer.uuid}/edit`;
      }
    },
    getSubjectLink(row) {
      if (!row.subject_type) {
        return null;
      }

      const subject_type = row.subject_type.replace("App\\Models\\", "").toLowerCase();
      let url = null;

      if (!row.subject) {
        return url;
      }

      switch (subject_type) {
        case 'feed':
          url = `/feeds/${row.subject.uuid}/edit`;
          break;
        case 'item':
          url = `/items/${row.subject.uuid}/edit`;
          break;
        case 'chaptermarker':
          url = `/chapter-markers/${row.subject.uuid}/edit-marker`;
          break;
        case 'episodedetail':
          if (row.properties.attributes.item) {
            url = `/items/${row.properties.attributes.item?.uuid}/edit`;
          }
          break;
        case 'storage':
          url = `/storage/${row.subject.uuid}/edit`;
          break;
        case 'storageffmpegdetail':
          url = `/storage/${row.properties.attributes.storage?.uuid}/edit`;
          break;
      }

      return url;
    },
  },
};
</script>

<style lang="scss" scoped>
  .filter-types {
    label {
      font-weight:bold;
      margin-top:2em;
    }
  }
</style>
